export default {
  noOptions: 'لا توجد خيارات',
  start: 'ابدأ',
  next: 'التالي',
  back: 'السابق',
  of: 'من',
  confirm: 'تأكيد',
  no_results: 'لا توجد نتائج!',
  yes: 'نعم',
  no: 'لا',
  cancel: 'إلغاء',
  reason: 'السبب',
  remove: 'حذف',
  change: 'تغيير',
  apply: 'تطبيق',
  date: 'التاريخ',
  edit: 'تعديل',
  total: 'المجموع',
  send: 'إرسال',
  resend: 'إعادة الإرسال',
  continue: 'متابعة',
  previous: 'السابق',
  customer_service: 'خدمة العملاء',
  link_account: 'ربط الحساب',
  enter_placeholder: 'أدخل {{name}}',
  select_placeholder: 'اختر {{name}}',
  choose_placeholder: 'اختر {{name}}',
  retry: 'إعادة المحاولة',
  all: 'الكل',
  save: 'حفظ',
  downloading: 'جاري التحميل',
  select: 'اختر',
  benefitsExpiryDateLabel: 'تاريخ الانتهاء: <date>{{expiryDate}}</date>',
  'iban_blocked_hours#one': '{{count}} ساعة و ',
  'iban_blocked_hours#two': 'ساعتين و ',
  'iban_blocked_hours#few': '{{count}} ساعة و ',
  'iban_blocked_hours#many': '{{count}} ساعات و ',
  'iban_blocked_hours#other': '{{count}} ساعات و ',
  'iban_blocked_minutes#one': '{{count}} دقيقة',
  'iban_blocked_minutes#two': 'دقيقتين',
  'iban_blocked_minutes#few': '{{count}} دقائق',
  'iban_blocked_minutes#many': '{{count}} دقائق ',
  'iban_blocked_minutes#other': '{{count}} دقائق',
} as const
